/* ==========================================================================
   AVVO — Mini-Warenkorb: Versandversprechen (Markup: AVVO-ANPASSUNG 6b in
   snippets/mini-cart.liquid) und korrekte Panel-Höhe am Telefon (siehe
   fitPhoneMiniCart). Eingebunden über AVVO-ANPASSUNG 7 in
   layout/theme.liquid.

   Rechnet in Schweizer Zeit (Europe/Zurich), unabhängig von der Uhr des
   Geräts. Versandtage: Mo–Fr ausser schweizweiten Feiertagen (seit
   29.09.2026, Liste bei isHoliday; kantonale Feiertage zählen nicht):
     Versandtag vor 18:00        → „Bestelle innert 2 Std. 14 Min., Versand noch heute"
     nächster Versandtag morgen  → „Jetzt bestellen, Versand morgen"
     nächster Versandtag Montag  → „Jetzt bestellen, Versand am Montag"
     sonst (z. B. nach Ostern)   → „Jetzt bestellen, Versand am Dienstag" (data-weekday)

   Die Texte stehen als data-Attribute am Element (aus den locales, im Admin
   übersetzbar). Warehouse ersetzt den Mini-Warenkorb nach jeder Änderung per
   innerHTML — ein MutationObserver setzt den Text danach neu.
   ========================================================================== */
(function () {
  var CUTOFF_MINUTES = 18 * 60;
  var DAY_LONG = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];

  function zurichNow() {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Zurich',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    }).formatToParts(new Date());
    var o = {};
    parts.forEach(function (p) { o[p.type] = p.value; });
    return {
      date: new Date(Date.UTC(+o.year, +o.month - 1, +o.day, 12)),   /* Mittag UTC: Tage zählen ohne Sommerzeit-Sprünge */
      minutes: (parseInt(o.hour, 10) % 24) * 60 + parseInt(o.minute, 10)
    };
  }

  /* Schweizweite Feiertage (Kundenentscheid 29.09.2026: nur nationale, keine
     kantonalen). Liste des Bundesamts für Strassen (Feiertage mit
     Sonntagsfahrverbot): Neujahr, Karfreitag, Ostermontag, Auffahrt,
     Pfingstmontag, 1. August, Weihnachten, Stephanstag. An diesen Tagen wird
     nicht verschickt und nicht zugestellt. Gleiche Liste in assets/avvo-produkt.js (Produktseite). */
  var DAY_MS = 86400000;
  var easterSunday = function (y) {                       /* Gauss/Meeus, gregorianisch */
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4;
    var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    var n = h + l - 7 * m + 114;
    return Date.UTC(y, Math.floor(n / 31) - 1, (n % 31) + 1, 12);
  };
  var holidayCache = {};
  var isHoliday = function (date) {                        /* date = Mittag UTC des Schweizer Kalendertags */
    var y = date.getUTCFullYear();
    if (!holidayCache[y]) {
      var e = easterSunday(y), list = {};
      [Date.UTC(y, 0, 1, 12), e - 2 * DAY_MS, e + DAY_MS, e + 39 * DAY_MS, e + 50 * DAY_MS,
        Date.UTC(y, 7, 1, 12), Date.UTC(y, 11, 25, 12), Date.UTC(y, 11, 26, 12)].forEach(function (t) {
        list[new Date(t).toISOString().slice(0, 10)] = true;
      });
      holidayCache[y] = list;
    }
    return !!holidayCache[y][date.toISOString().slice(0, 10)];
  };
  var isWorkday = function (date) { var d = date.getUTCDay(); return d >= 1 && d <= 5 && !isHoliday(date); };

  function escapeHtml(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function render(el) {
    var target = el.querySelector('[data-avvo-dispatch-text]');
    if (!target) return;

    var now = zurichNow();
    var left = CUTOFF_MINUTES - now.minutes;
    var html;

    if (isWorkday(now.date) && left > 0) {
      var h = Math.floor(left / 60);
      var m = left % 60;
      var time = (h > 0 ? h + ' ' + el.getAttribute('data-hours') + ' ' : '') + m + ' ' + el.getAttribute('data-minutes');
      var parts = (el.getAttribute('data-today') || '').split('{time}');
      html = escapeHtml(parts[0]) + '<strong>' + escapeHtml(time) + '</strong>' + escapeHtml(parts.slice(1).join('{time}'));
    } else {
      var ship = now.date;
      do { ship = new Date(ship.getTime() + DAY_MS); } while (!isWorkday(ship));
      var days = Math.round((ship.getTime() - now.date.getTime()) / DAY_MS);
      if (ship.getUTCDay() === 1) {
        html = escapeHtml(el.getAttribute('data-monday') || '');
      } else if (days === 1) {
        html = escapeHtml(el.getAttribute('data-tomorrow') || '');
      } else {
        html = escapeHtml((el.getAttribute('data-weekday') || 'Jetzt bestellen, Versand am {day}').replace('{day}', DAY_LONG[ship.getUTCDay()]));
      }
    }

    /* Nur bei Änderung schreiben. Verglichen wird mit dem zuletzt gesetzten
       Wert (Attribut, vom Observer nicht beobachtet) — ein Vergleich mit
       innerHTML könnte wegen der Serialisierung nie gleich sein und den
       Observer endlos auslösen. */
    if (target.getAttribute('data-avvo-last') !== html) {
      target.setAttribute('data-avvo-last', html);
      target.innerHTML = html;
    }
  }

  function update() {
    var els = document.querySelectorAll('[data-avvo-dispatch]');
    for (var i = 0; i < els.length; i++) render(els[i]);
  }

  /* Telefon: Warehouse setzt die Höhe des offenen Mini-Warenkorbs auf
     Fensterhöhe minus Höhe der Header-Sektionen (theme.js,
     _calculateMiniCartHeight). Die Header-Sektion enthält aber auch die
     immer sichtbare Suchzeile (70px), die das Panel überdeckt — es endete
     deshalb 70px über dem Bildschirmrand. Hier: gleiche Rechnung ab der
     tatsächlichen Oberkante des Panels (offsetTop ist von der
     Öffnungsanimation mit transform: scale unbeeinflusst). Geschrieben wird
     nur bei Abweichung — Warehouse setzt die Werte bei jedem Öffnen und
     jeder Grössenänderung neu, der Observer korrigiert danach. */
  var phone = window.matchMedia('(max-width: 640px)');

  function fitPhoneMiniCart() {
    var miniCart = document.getElementById('mini-cart');
    if (!miniCart || !phone.matches || miniCart.getAttribute('aria-hidden') !== 'false') return;
    var parent = miniCart.offsetParent;
    if (!parent) return;

    var top = parent.getBoundingClientRect().top + miniCart.offsetTop;
    var max = Math.floor(window.innerHeight - top) + 'px';
    if (miniCart.style.maxHeight !== max) miniCart.style.maxHeight = max;

    var content = miniCart.querySelector('.mini-cart__content');
    var recap = miniCart.querySelector('.mini-cart__recap');
    if (content && recap) {
      var contentMax = Math.floor(window.innerHeight - top - recap.clientHeight) + 'px';
      if (content.style.maxHeight !== contentMax) content.style.maxHeight = contentMax;
    }
  }

  function init() {
    update();
    var miniCart = document.getElementById('mini-cart');
    if (miniCart && 'MutationObserver' in window) {
      new MutationObserver(function () {
        update();
        fitPhoneMiniCart();
      }).observe(miniCart, { childList: true, subtree: true });
      /* Öffnen (aria-hidden) und Warehouses Höhenwerte (style) am Panel */
      new MutationObserver(fitPhoneMiniCart).observe(miniCart, { attributes: true, attributeFilter: ['aria-hidden', 'style'] });
    }
    window.addEventListener('resize', fitPhoneMiniCart);
    setInterval(update, 30000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
